/**
 * The collage (1.168.0): how two to four photos of a post stand together.
 *
 * Decided from use as an arrangement of the post's own photos, not a
 * composed picture: the server keeps the style (`Collage.php`), the photos
 * stay photos. **Which layouts fit which number comes from the server**
 * (`collage_layouts` with the settings), so the sheet offers what the server
 * takes; this file only names them for the eye and turns a style into the
 * variables of the stylesheet.
 */

export interface CollageStyle {
  layout: string
  radius: number
  gap: number
  color: string
}

export const COLLAGE_FEWEST = 2
export const COLLAGE_MOST = 4

/**
 * The layout that fits a number of photos: the one asked for when it fits,
 * else the first of the list (the server's default). After a photo was
 * added or removed in the sheet the old layout may not fit any more; the
 * sheet then shows this one instead of offering a send the server refuses.
 */
export function fittingLayout(layouts: Record<string, string[]>, count: number, wanted: string): string {
  const list = layouts[String(count)] ?? []
  return list.includes(wanted) ? wanted : (list[0] ?? wanted)
}

/**
 * The style as variables of `.collage`: three numbers from the server or the
 * sheet, the one thing a class cannot know. The colour is `#rrggbb`, checked
 * by the server before it is stored.
 */
export function collageVariables(style: CollageStyle): Record<string, string> {
  return {
    '--collage-radius': `${style.radius}px`,
    // The frame's corner (1.169.0): as `Collage::outerRadius()` on the server.
    '--collage-outer-radius': `${style.radius > 0 ? style.radius + style.gap : 0}px`,
    '--collage-gap': `${style.gap}px`,
    '--collage-color': style.color,
  }
}
